// REACT
import { useContext } from "react";

// CONTEXT
import { maincontext } from "../context/maincontext";

// ASSETS
import languagePack from "../assets/languages/languagePack";

// COMPONENTS
import ToolHeader from "../components/common/ToolHeader"
import Upload from "../components/upload/Upload";

export default function ShopManager(params) {
    const { language } = useContext(maincontext);

    const baseUploadUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}import_shop_code`;

    const templateListUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}templates/list_shop_templates`;
    const templateDownloadUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}templates/get_template`;

    return (
        <>
            <ToolHeader
                toolHeader={languagePack[language].shopmanager.title}
                icon={"shop"}
            />
              <Upload
                uploadUrl={baseUploadUrl}
                templateFetchUrl={templateListUrl}
                templateDownloadBaseUrl={templateDownloadUrl}
            />
        </>
    )
}